// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-content{background:linear-gradient(.62deg,#fff 53.58%,#eaf0f6 106.02%)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
